// extracted by mini-css-extract-plugin
export default {"App":"textarea_App__mFbp6","loadingWrapper":"textarea_loadingWrapper__U+vzx","loading":"textarea_loading__aQowW","wrapper":"textarea_wrapper__T9XVG","title":"textarea_title__O5fTY"};